import { gql } from "@apollo/client";

export const GET_SUPPORT = gql`
query GetSupport($page: Int, $limit: Int, $filter: String, $sort: userSort, $search: String, $from: String, $to: String, $status: Boolean, $ticketstatus: String, $tickettype: String) {
  getSupport(page: $page, limit: $limit, filter: $filter, sort: $sort, search: $search, from: $from, to: $to,status: $status, ticketstatus: $ticketstatus,tickettype: $tickettype) {
    count
    data {
      id
      name
      mobile
      awbNo
      orderID
      message {
        sender
        message
        createdAt
        attachments
      }
      createdAt
      order {
        id
        status
        awb_number
      }
      issue_type
      ticketID
      issue_category
      status
      ticket_type_issue
    }
  }
}
`

export const UPDATE_SUPPORT = gql`

mutation Mutation($updateSupportId: String, $isActive: Boolean) {
  updateSupport(id: $updateSupportId, isActive: $isActive)
}
`
export const GET_CUSTOMER_TICKET = gql`
query GetSupportForCustomer($customerId :String,$status: Boolean, $to: String, $ticketstatus:String, $from: String, $search: String, $sort: userSort, $page: Int, $limit: Int, $filter: String,$tickettype: String) {
  getSupportForCustomer(customerId:$customerId,status: $status, to: $to, ticketstatus:$ticketstatus,from: $from, search: $search, sort: $sort, page: $page, limit: $limit, filter: $filter,tickettype: $tickettype) {
    count
    data {
      id
      name
      mobile
      awbNo
      orderID
      message {
        sender
        message
        createdAt
        attachments
      }
      createdAt
      order {
        status
        awb_number
      }
      issue_type
      ticketID
      issue_category
      status
      ticket_type_issue
    }
  }
} 
`

export const CREATE_TICKET_REMARK = gql`
  mutation AddMessageToSupport($ticketId: String!, $messageInput: MessageInput) {
  addMessageToSupport(ticketId: $ticketId, messageInput: $messageInput) {
    status
    message
}
}
`
export const GET_MESSAGE = gql`
query GetMessagesByTicketId($ticketId: String!) {
  getMessagesByTicketId(ticketID: $ticketId) {
    id
    name
    mobile
    awbNo
    orderID
    message {
      sender
      message
      createdAt
      attachments
    }
    createdAt
    isActive
    order {
      order_number
      awb_number
      ProductPrice
      ProductName  
    }
    issue_type
    ticketID
    issue_category
    status
    ticket_type_issue
  }
}
`

export const UPDATE_TICKET_STATUS = gql`
  mutation UpdateSupportTicketStatus($ticketId: String!, $newStatus: String!) {
    updateSupportTicketStatus(ticketId: $ticketId, newStatus: $newStatus) {
      status
      message
      support {
        id
        status
      }
    }
  }
`;